import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import commentifyTypes from './types';
import commentsServices from './services';
import commentsActions from './actions';

function* getCommentsRequest(action) {
	try {
		let response = yield sagaCallService(
			() => commentsServices.getComment(action.payload),
			action
		);
		yield put(commentsActions.getCommentsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, commentsActions.getCommentsFailure);
	}
}

function* replyToCommentRequest(action) {
	try {
		let response = yield sagaCallService(
			commentsServices.reply,
			action,
			action.payload
		);
		yield put(commentsActions.commentsReplySuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, commentsActions.commentsReplyFailure);
	}
}

const commentSagas = [
	takeEvery(commentifyTypes.NEWEST_COMMENTS.REQUEST, getCommentsRequest),
	takeLatest(commentifyTypes.REPLY.REQUEST, replyToCommentRequest),
];

export default commentSagas;
